"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Returns typeof value
 *
 * @module typeOf
 * @func
 * @since 1.0.0
 * @param {*} val
 * @return {string}
 * @example
 *
 *     typeOf([]); //=> 'object'
 *     typeOf(undefined); //=> 'undefined'
 *     typeOf(5); //=> 'number'
 */

var typeOf = function typeOf(val) {
  return typeof val === "undefined" ? "undefined" : _typeof(val);
};

exports.default = typeOf;